<template>
	<div class="message-box" :class="colorClass">
		<p class="message-box__content" :class="withImageClass">
			<slot></slot>
		</p>
		<p class="message-box__signature">{{ signature }}</p>
	</div>
</template>

<script>
import "./MessageBox.scss";

export default {
	data() {
		return {
			colorClass: `message-box--${this.color}`,
			withImageClass: this.withImage && `message-box__content--with-image`
		};
	},
	name: "MessageBox",
	props: {
		color: String,
		withImage: Boolean,
		signature: String
	}
};
</script>
